import React from 'react';
import BaseChart from '../BaseChart/BaseChart';
import * as ChartLineStyle from './ChartLineStyle';
import { ChartLineProps } from 'types/Chart';
import { useAppSelector } from '../../../redux/hooks';

const ChartLine: React.FC<ChartLineProps> = ({ componentClick, ariaLabel, details, labels }) => {

  const {isContrast} = useAppSelector(state => state.general);

  const options = {
    ...ChartLineStyle.chartOptions(details, isContrast),
  };
  const data = {
    labels,
    datasets: ChartLineStyle.getLineDataWithDesign(isContrast),
  };

  const hiddenFirstChart = (chartInstance: any) => {
    const numOfYears = chartInstance.getVisibleDatasetCount();
    if (numOfYears > 3) {
      for (let i = 0; i < numOfYears - 3; i++) {
        const firstDatasetMeta = chartInstance.getDatasetMeta(i);
        firstDatasetMeta.hidden = !firstDatasetMeta.hidden;
        chartInstance.update();
      }
    };
  }
  return (
    <BaseChart
      chartType="line"
      data={data}
      options={options}
      componentClick={componentClick}
      onChartCreated={hiddenFirstChart}
      ariaLabel={ariaLabel}
    />
  );
};

export default ChartLine;
